// Reuse the ordinary customer/product forms for visible app-controlled work.
function InvoiceControlRecordForm({ form, session, busy, error }) {
  const save = async (draft) => {
    if (!String(draft.name || '').trim()) { session.formSaveFailed(form.id, 'control.incomplete'); return; }
    if (!session.beginFormSave(form.id)) return;
    try {
      const backend = window.PlummeBackend;
      const record = form.kind === 'customer'
        ? await backend.saveCustomerRecord({ ...draft, id: form.recordId || form.id })
        : form.kind === 'supplier'
          ? await backend.saveSupplierRecord({ ...draft, id: form.recordId || form.id })
          : await backend.saveProductRecord({ ...draft, id: form.recordId || form.id });
      if (!record?.id) throw new Error('control.failed');
      await session.formSaved(form.id, record);
    } catch (error) { session.formSaveFailed(form.id, error.message || 'control.failed'); }
  };
  const close = () => session.cancelForm(form.id);
  const initial = form.isNew ? { ...form.initial, id: undefined } : form.initial;
  // Registry routes can open this form before the lazy invoice page is loaded.
  const records = window.PlummeBackend.appState || {};
  if (form.kind === 'customer') return <CustomerModal portal customer={form.isNew ? null : initial} initial={initial} autoSave={form.autoSave} busy={busy} error={error}
    existing={(records.customers || []).filter((customer) => customer && customer.status !== 'archived').map((customer) => ({ ...customer, org: customer.organizationNumber || '' }))} onClose={close} onSave={save} />;
  if (form.kind === 'supplier') return <SupplierEditModal supplier={initial} autoSave={form.autoSave} onClose={close} onSave={save} />;
  const vat = window.PlummeBackend.normalizeSalesVatOption(initial.vatSelection);
  return <ProductModal open autoSave={form.autoSave} busy={busy} error={error} product={{ ...initial, vat: vat.rate, vatTreatment: vat.treatment }}
    takenNrs={(records.products || []).filter((product) => product && product.status !== 'archived').map((product) => product.nr)} onClose={close} onSave={save} />;
}
Object.assign(window, { InvoiceControlRecordForm });
